import { Component, ViewChild, ElementRef } from '@angular/core';
import { Content } from 'ionic-angular';
import { NavController } from 'ionic-angular';
import { CameraPreview, CameraPreviewPictureOptions, CameraPreviewOptions, CameraPreviewDimensions } from '@ionic-native/camera-preview';
import { Headers, Http, HttpModule } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AlertController } from 'ionic-angular';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { StatusBar } from '@ionic-native/status-bar';
import { NavigationBarColor } from 'ionic-plugin-navigation-bar-color';
import { Platform } from 'ionic-angular';
import { Keyboard } from 'ionic-angular';
declare var window;


interface IFrameInput {
  "Id":number,
  "PrecioTotal":any,
  "PrecioSubtotal": any,
  "IdCustomer": any,
  "Type": string,
  "SavedCard":boolean,
  "Card": {
    "paymentData": any,
    "tarjetaSeisDigitos":any
  },
}


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

  cameraStatus: string;
  picture: string;
  isTransparent: boolean;
  isTablet: boolean;
  cameraPreviewOpts: CameraPreviewOptions;
  pictureTaken = false;
  loginSuccess = false;
  loginStart   = true;
  nameItem         = "";
  passwordItem     = "";
  countPedidos     = 0;
  location         = '';
  alertModal       = '';
  showPedidosContainer = false;
  showMenu           = false;
  showPayment        = false;
  showBestSeller     = false;
  showBestSellerMenu = false;
  adjuntarComprobante = false;
  pagoTarjeta         = false;
  hideCam             = false;
  viewSelectCuotas      = false;
  showPedidosPendientes = false;
  id       = 0;
  bestProducts: any;
  webProducts: any;
  descuento: any;
  descuentoCol: any;
  descuentoDeudor: any;
  brandIndicator = "";
  // eyewearuruguaysrl@gmail.com
  toEmail        = "eyewearuruguaysrl@gmail.com";

  sendPedido   = {
      id: 0,
      foto: "",
      cantidad: "1",
      tipo: 'comun'
  }
  ordenarPedido = {
    Id_Cliente:0,
    Tipo:"",
    Total:"",
    Subtotal:"",
    Observacion:"",
    ComprobantePago:"",
    Id_Pago:"",
    Id_Customer: false
  }
  cantidad        = "1";
  waitCam         = false;
  checkVisit      = false;
  disableBtn      = false;
  pedidosList: any;
  ordenList: any;
  isApp           = false;
  disabledUrgentes = false;
  txtUrgentes     = "Enviar todos urgente!";
  precioSubtotal  = "";
  precioTotal     = "";
  nombreCliente   = "";
  fantasiaCliente = "";
  errorLogin      = "";
  usd             = 1;
  win             = window;
  imageExample    = 'data:image/jpeg;base64,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';
  API = 'https://api.lexart.com.uy/eyewear-api/';
  MAIL_API = 'https://mail-api.lexartlabs.com/mail/smtp/new/notify';
  API_MERCADOPAGO = 'https://mercadopago.apps.lexartlabs.com/eyewear/';
  // POOL     = 'https://lexartlabscom.ipage.com/eyewear-app/api/';
  POOL        = this.API;
  visitDate: any;
  modal_show_pedido = false;
  modal_fade_pedido = false;
  modal_hiding_pedido = false;
  modal_title = 'Pedido';
  modal_content= '';
  //
  modal_show_orden = false;
  modal_fade_orden = false;
  modal_hiding_orden = false;
  //
  modal_show = false;
  modal_fade = false;
  modal_hiding = false;
  modalPedido: any;
  modalInd: any;
  sendDelete = false;
  visitaApi: any;
  imagenComprobante: any;
  tipoPayment = "";
  sinOrdenar = false;
  /* SOLO PAGOS WEB VARIABLES */
  viewTarjetaTitle = "";
  arrYears = [];
  disabledButton = false;
  tieneTarjeta   = false;
  tarjetaSeisDigitos = "";
  imagenTarjeta      = "";
  arrayInstallments  = [];
  customerTarjetas   = [];
  tecladoAbierto = false;
  tipoTarjeta        = {
    credito: false,
    debito: false
  };
  paymentData = {
    cardId: false,
    cardNumber:"",
    email:"",
    securityCode:"",
    cardExpirationMonth:"",
    cardExpirationYear:"",
    cardholderName:"",
    docType:"CI",
    docNumber:"",
    installments: 1,
    issuer_id: "",
    amount: 0,
    description:"",
    paymentMethodId: "",
    token: "",
    Id_Customer: false,
    add_card: false,
    Id_Pago: false,
    version: 4
  }
  /*paymentData = {
    cardId: false,
    cardNumber:"5031 7557 3453 0604	",
    email:"test_user_78447660@testuser.com",
    securityCode:"123",
    cardExpirationMonth:"11",
    cardExpirationYear:"2025",
    cardholderName:"APRO",
    docType:"CI",
    docNumber:"44936756",
    installments: 1,
    issuer_id: "0",
    amount: 0,
    description:"",
    paymentMethodId: "",
    token: "",
    Id_Customer: false,
    add_card: false,
    Id_Pago: false
  }

  /* FIN PAGOS WEB VARIABLES */
  
  constructor(public keyboard: Keyboard, public navigationBarColor: NavigationBarColor,public navCtrl: NavController, private cameraPreview: CameraPreview, private http: Http, public alertCtrl: AlertController, private screenOrientation: ScreenOrientation, public plt: Platform, private statusBar: StatusBar) {
    this.isTransparent = false;
    // set status bar to white
    this.statusBar.backgroundColorByHexString('#ffffff');
    this.navigationBarColor.backgroundColorByHexString('#ffffff');
    this.cameraPreviewOpts = {
      x: 0,
      // y: window.screen.height/2 - window.screen.width*2/3,
      y: 0,
      width: window.screen.width,
      //height: window.screen.width*4/3,
      height:window.screen.height,
      camera: 'rear',
      tapPhoto: false,
      previewDrag: false,
      toBack: true,
      alpha: 1
    };
    this.pedidosList  = [];
    this.bestProducts = [];
    this.webProducts  = [];
    this.isApp = (!document.URL.startsWith('http'));
    this.descuento = "";
    this.descuentoCol = "";
    this.iFrameEntryInfo();
  }


  testDataSetup() {
    this.paymentData = {
      cardId: false,
      cardNumber:"5031 7557 3453 0604	",
      email:"test_user_78447660@testuser.com",
      securityCode:"123",
      cardExpirationMonth:"11",
      cardExpirationYear:"2025",
      cardholderName:"APRO",
      docType:"CI",
      docNumber:"44936756",
      installments: 1,
      issuer_id: "0",
      amount: 0,
      description:"",
      paymentMethodId: "",
      token: "",
      Id_Customer: false,
      add_card: false,
      Id_Pago: false,
      version: 4
    }
  }

  setupData(data) {
    try {
      this.ResetearPedido();

      const {Id,PrecioTotal,PrecioSubtotal,IdCustomer,Type,Card,SavedCard}:IFrameInput = data;

      if(!Id) console.log("IFRAME","IFRAME","Falta Campo Id");
      if(!PrecioTotal) console.log("IFRAME","IFRAME","Falta Campo PrecioTotal");
      if(!IdCustomer) console.log("IFRAME","IFRAME","Falta Campo IdCustomer");
      if(!Type) console.log("IFRAME","Falta Campo Type");
      if(!Card) console.log("IFRAME","Falta Campo Type");
      if(!SavedCard) console.log("IFRAME","Falta Campo Type");
      if(!SavedCard) console.log("IFRAME","Falta Campo Type");
      if(!PrecioSubtotal) console.log("IFRAME", "Falta Precio SubTotal");

      var usdPrecioTotal = parseFloat(PrecioTotal);
      var usdPrecioSubtotal = parseFloat(PrecioSubtotal);
      console.log("TOTAL EN DOLAR",usdPrecioTotal.toFixed(2),PrecioTotal);
      console.log("SUBTOTAL EN DOLAR",usdPrecioSubtotal.toFixed(2),PrecioSubtotal);
      this.id = Id;
      this.precioTotal = usdPrecioTotal.toFixed(2);
      this.precioSubtotal = usdPrecioSubtotal.toFixed(2);
      this.ordenarPedido.Id_Customer = IdCustomer;
      this.paymentData.Id_Customer = IdCustomer;
      const typeCard = Type;      
      switch (typeCard) {

        case "Debit":
          window.scrollTo(0,0);
          this.debitCard();
          break;

        case "Credit":
          window.scrollTo(0,0);
          this.creditCard();
          break;

        default:
          console.log("IFRAME","Tipo de tarjeta no válido");
          break;
      }

      if(SavedCard == true) {
        window.scrollTo(0,0);
        const {paymentData,tarjetaSeisDigitos} = Card;
        this.paymentData = paymentData;
        this.tarjetaSeisDigitos = tarjetaSeisDigitos;
        this.tieneTarjeta        = true;
      }
      //this.testDataSetup();
    } catch(e) {
      console.log("IFRAME","Error con el Iframe::", e.message);
    }
  }

  iFrameEntryInfo() {
    window.onmessage = (e) => {
      try {
          if (e && e.data) {
              const dataString = e.data;
              //const dataString = '{"keyboard": true}';
              const data = JSON.parse(dataString);
              if(data.Card){
                if(data.Card.paymentData){
                  if(data.Card.paymentData.cardType){
                    if(data.Card.paymentData.cardType == "credit_card"){
                      data.Type = "Credit";
                    }else{
                      data.Type = "Debit";
                    } 
                  }
                }
              }
              console.log("IFRAME","DATA::", data);
              if(data) {
                if(data.type == "method" && data.state == "Pagar") {
                  this.pagar();
                }
              }
              /*
              if(data && data.keyboard) {
                if(data.keyboard == "false") {
                  data.keyboard = false;
                } else if (data.keyboard == "true") {
                  data.keyboard = true;
                }
                this.tecladoAbierto = data.keyboard;
              }*/
              if(data.Id) {
                this.setupData(data);
              }
          }
        } catch(err) {
          console.log("IFRAME","No se pudo obtener la información");
          console.log("IFRAME",e.message);
          console.log(err);
        }
    };
  }

  emitState({state}) {
    const msg = {type: "state",state};
    window.top.postMessage(JSON.stringify(msg),"*")
  }

  emitModal({title,message,dismiss}) {
    const msg = {type: "modal",title,message,dismiss};
    window.top.postMessage(JSON.stringify(msg),"*")
  }

  emitMethod({state}) {
    const msg = {type: "method",state};
    window.top.postMessage(JSON.stringify(msg),"*")
  }

  pictureOpts: CameraPreviewPictureOptions = {
    width: 500,
    height: 500,
    quality: 50
  };

  startCamera() {
    this.cameraPreview.startCamera(this.cameraPreviewOpts).then(
      (res) => {
        this.isTransparent = true;
        console.log("IFRAME",res);
        this.cameraStatus = 'camera started';
      },
      (err) => {
        console.log("IFRAME",err);
        this.cameraStatus = 'camera failed to start';
      });  
  }

  stopCamera() {
    console.log("IFRAME","stop camera :");
    this.cameraPreview.stopCamera().then(
      (res) => {
        this.isTransparent = false;
        console.log("IFRAME",res);
        this.cameraStatus = 'camera stopped';
      },
      (err) => {
        console.log("IFRAME",err);
        this.cameraStatus = 'camera failed to stop';
      }
    )
  }

  login(){
    let API = this.API;
    this.errorLogin = "";
    console.log("IFRAME","login: ", this.nameItem, this.passwordItem);

    this.http.post(API + 'login.php', {email: this.nameItem, password: this.passwordItem}).subscribe( (res) => {
      console.log("IFRAME","hola: ", res.json() );
      if(res.json().response){
        this.visitaApi    = res.json().response.visita;

        if(this.visitaApi.Visita == "1"){
          this.checkVisit = true;
          this.visitDate  = new Date(this.visitaApi.Fecha_Visita);
          this.visitDate.setDate(this.visitDate.getDate() + 1);
        }
        this.loginSuccess = true;
        this.loginStart = false;
        console.log("IFRAME","Login Count 1");
        this.CountPedidos(res.json().response.pedidos);
        this.id           = res.json().response.id;
        this.pedidosList  = res.json().response.pedidos;
        this.ordenList    = res.json().response.ordenes;
        this.nombreCliente= res.json().response.nombre;
        this.fantasiaCliente = res.json().response.fantasia;

        console.log("IFRAME","this.pedidosList: ", this.pedidosList);


        localStorage.setItem("userEmail", res.json().response.email);
        localStorage.setItem("userPassword", res.json().response.contrasena);

        if(this.loginSuccess){
            let theSeconds = 5000;
            this.ClienteCustomerId();
            // SET UP - POLLER APP
            /*
            setInterval( () => {
              console.log("IFRAME","run poller ::");
              this.http.get(API + 'descuento-app.php').subscribe( (rz) => {
                let descuento     = rz.json().response.descuento;
                let descuentoCol  = rz.json().response.descuentoCol;
                let descuentoDeudor  = rz.json().response.descuentoDeudor;

                if(this.descuento != descuento || 
                  this.descuentoCol != descuentoCol || 
                  this.descuentoDeudor != descuentoDeudor){

                  console.log("IFRAME","try distinct ::");
                  this.descuento     = descuento;
                  this.descuentoCol  = descuentoCol;
                  this.descuentoDeudor = descuentoDeudor;
                }
              })
              this.http.get(API + 'pedidos.php?idCliente=' + this.id).subscribe( (rx) => {
                this.sinOrdenar = rx.json().sinOrdenar;

                if(rx.json().ordenes){
                  if(this.ordenList && this.ordenList.length > 0 ){
                    if(rx.json().ordenes.length > 0){
                      rx.json().ordenes.map((orden)=>{
                        var exist = false;
                        this.ordenList.map((ordenMob)=>{
                          if(orden.Id == ordenMob.Id){
                            exist = true;
                          }
                        });
                        if(!exist){
                          this.ordenList.push(orden);
                        }
                      });
                    }
                  }else{
                    this.ordenList = rx.json().ordenes;
                  }
                }

                if(rx.json().response){
                  this.CountPedidos(rx.json().response);



                  let isIn        = false;
                  let maxUrgentes = 0;
                  let precioSubtotal = 0;
                  let precioTotal = 0;

                  if(this.pedidosList.length > 0){
                    if(rx.json().response.length > 0){
                      this.disableBtn  = false;
                      rx.json().response.map( (pedido) => {
                        this.pedidosList.map( (pedMob) => {
                          if(pedido.Id == pedMob.Id){
                            pedMob.Borrado          = pedido.Borrado;
                            pedMob.Tipo             = pedido.Tipo;
                            pedMob.Precio           = pedido.Precio;
                            pedMob.Precio_Anterior  = pedido.Precio_Anterior;
                            pedMob.Precio_Iva       = pedido.Precio_Iva;
                            pedMob.Descuento        = pedido.Descuento ? pedido.Descuento : null;
                            pedMob.Nuevo            = pedido.Productos ? pedido.Productos.Nuevo : null;
                            pedMob.Cantidad         = pedido.Cantidad ? parseInt(pedido.Cantidad) : 1;
                            if(pedido.IdPedidosOrdenApp){
                              pedMob.IdPedidosOrdenApp = pedido.IdPedidosOrdenApp;
                            }
                            // if(pedido.Tipo !='pendiente' && pedido.Tipo !='enviado'){
                            //   precioSubtotal  += parseFloat(pedido.Precio) * pedMob.Cantidad;
                            //   precioTotal     += parseFloat(pedido.Precio_Iva) * pedMob.Cantidad;
                            //   this.precioSubtotal = precioSubtotal.toFixed(2);
                            //   this.precioTotal = precioTotal.toFixed(2);
                            // } 
                          }
                        })
                      })
                      // if(rx.json().ordenes.length > 0){
                      //   rx.json().ordenes.map( (orden) => {
                      //     let exist = false;
                      //     this.pedidosList.map( (pedMob) => {
                      //       if(orden.ComprobantePago && orden.ComprobantePago == pedMob.ComprobantePago){
                      //         exist = true;
                      //       }else if(orden.Id_Pago && orden.Id_Pago == pedMob.Id_Pago){
                      //         exist = true;
                      //       }
                      //     })
                      //     if(!exist){
                      //       this.pedidosList.push(orden);
                      //     }
                      //   })
                      // }
                    }else{
                      this.pedidosList = [];
                      this.countPedidos = 0;
                    }
                  } else {
                    this.disableBtn  = true;
                    this.pedidosList = rx.json().response;
                    this.countPedidos = 0;
                  }

                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "urgente" || item.Tipo == "enviado"){
                      maxUrgentes++;
                    }
                  });

                  // console.log("IFRAME","count pedidos: ", rx.json().response.length, maxUrgentes);

                  if(maxUrgentes < rx.json().response.length){
                    if(this.countPedidos == 1){
                      if(!this.disabledUrgentes){
                        this.txtUrgentes = "Enviar urgente!";
                      }
                    } else {
                      if(!this.disabledUrgentes){
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                    }
                  } else {
                      // console.log("IFRAME","txt urgente: ", maxUrgentes, rx.json().response.length);
                      this.txtUrgentes = "Envío urgente confirmado!";
                      this.disabledUrgentes = true;
                  }

                  rx.json().response.map( (item) => {
                    // SI EXISTE POR LO MENOS UNO QUE NO SEA
                    // URGENTE
                    // console.log("IFRAME","track item: ", item);
                    if(item.Tipo != "urgente"){
                      // console.log("IFRAME","not urgente :", item);

                      if(this.countPedidos == 1){
                          this.txtUrgentes       = "Enviar urgente!";
                          this.disabledUrgentes  = false;
                      } else {
                        this.disabledUrgentes  = false;
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                      return;
                    }
                  });

                  let maxEnviados  = 0;
                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "enviado"){
                      maxEnviados++;
                    }
                  });
                  
                  if(maxEnviados == this.pedidosList.length){
                    this.disableBtn  = true;
                  }

                } else {
                  this.disableBtn  = true;
                  console.log("IFRAME","this.disableBtn: ", this.disableBtn);
                }
              })
            }, theSeconds);*/
          }

        //this.startCamera();
        this.showPedidos();
      } else {
        this.errorLogin = res.json().err;
        this.CerrarSession();
      }
    })
    
  }

  getSizes() {
    this.cameraPreview.getSupportedPictureSizes().then(
      dimensions => {
        dimensions.forEach(function(dimension) {
          console.log("IFRAME",dimension.width + 'x' + dimension.height);
        });
      },
      error => {
        console.log("IFRAME",error);
      }
    );
  }
  CountPedidos(pedidos){
    if(pedidos && pedidos.length > 0){
      this.countPedidos = 0;
      pedidos.forEach((pedido,index)=>{
        if(pedido.IdPedidosOrdenApp == null){
          this.countPedidos += parseInt(pedido.cantidad ? pedido.cantidad : pedido.Cantidad);
        }
      })
    }else{
      this.countPedidos = 0;
    } 
    console.log("IFRAME","countPedidos: ", this.countPedidos);
  }
  showPedidos(iframe?:boolean){
    if(iframe) {
      this.emitState({
        state:"pedidos"
      });
      return;
    }
    console.log("IFRAME","show pedido: ");
    // this.stopCamera();
    this.isTransparent = false;
    this.showPedidosContainer = true;
    this.showPedidosPendientes = false;
    this.showBestSellerMenu   = false;
    this.showBestSeller       = false;
    this.loginSuccess         = false;
    this.loginStart           = false;
    this.showPayment          = false;
    this.showMenu              = false;
    this.adjuntarComprobante = false;
    this.pagoTarjeta         = false;
    this.viewSelectCuotas      = false;
    this.imagenComprobante = null;

    let API = this.API;
    console.log("IFRAME","login: ", this.nameItem, this.passwordItem);
    console.log("IFRAME","this.pedidosList: ", this.pedidosList);

    this.http.get(API + 'pedidos.php?idCliente=' + this.id).subscribe( (res) => {
      console.log("IFRAME","response pedidos: ", res.json(), res.json().response.length );
      if(res.json().ordenes){
          if(this.ordenList && this.ordenList.length > 0 ){
            if(res.json().ordenes.length > 0){
              res.json().ordenes.map((orden)=>{
                var exist = false;
                this.ordenList.map((ordenMob)=>{
                  if(orden.Id == ordenMob.Id){
                    exist = true;
                  }
                });
                if(!exist){
                  this.ordenList.push(orden);
                }
              });
            }
          }else{
            this.ordenList = res.json().ordenes;
          }
        }
      if(res.json().response){
          this.pedidosList   = res.json().response;
          this.ordenList    = res.json().response.ordenes;
          console.log("IFRAME","Show Pedidos");
          this.CountPedidos(res.json().response);

                  let isIn        = false;
                  let maxUrgentes = 0;
                  let precioSubtotal = 0;
                  let precioTotal = 0;

                  if(this.pedidosList.length > 0){
                    if(res.json().response.length > 0){
                      this.disableBtn  = false;
                      res.json().response.map( (pedido) => {
                        var pedidoExist = false;
                        this.pedidosList.map( (pedMob) => {
                          if(pedido.Id == pedMob.Id){
                            pedidoExist             = true;
                            pedMob.Borrado          = pedido.Borrado;
                            pedMob.Tipo             = pedido.Tipo;
                            pedMob.Precio           = pedido.Precio;
                            pedMob.Precio_Anterior  = pedido.Precio_Anterior;
                            pedMob.Precio_Iva       = pedido.Precio_Iva;
                            pedMob.Descuento        = pedido.Descuento ? pedido.Descuento : null;
                            pedMob.Nuevo            = pedido.Productos ? pedido.Productos.Nuevo : null;
                            pedMob.Cantidad         = pedido.Cantidad ? parseInt(pedido.Cantidad) : 1;
                            if(pedido.IdPedidosOrdenApp){
                              pedMob.IdPedidosOrdenApp = pedido.IdPedidosOrdenApp;
                            }
                          }
                        })
                        if(!pedidoExist){
                          this.pedidosList.push(pedido);
                        }
                      })
                    }else{
                      this.pedidosList = [];
                      this.countPedidos = 0;
                    }
                  } else {
                    this.disableBtn  = true;
                    this.pedidosList = res.json().response;
                    this.countPedidos = 0;
                  }

                  //console.log("IFRAME","this.disableBtn: ", this.disableBtn);
                  
                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "urgente" || item.Tipo == "enviado"){
                      maxUrgentes++;
                    }
                  });

                  // console.log("IFRAME","count pedidos: ", rx.json().response.length, maxUrgentes);

                  if(maxUrgentes < res.json().response.length){
                    if(this.countPedidos == 1){
                      if(!this.disabledUrgentes){
                        this.txtUrgentes = "Enviar urgente!";
                      }
                    } else {
                      if(!this.disabledUrgentes){
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                    }
                  } else {
                      // console.log("IFRAME","txt urgente: ", maxUrgentes, rx.json().response.length);
                      this.txtUrgentes = "Envío urgente confirmado!";
                      this.disabledUrgentes = true;
                  }

                  res.json().response.map( (item) => {
                    // SI EXISTE POR LO MENOS UNO QUE NO SEA
                    // URGENTE
                    // console.log("IFRAME","track item: ", item);
                    if(item.Tipo != "urgente" || item.Tipo == "enviado"){
                      //console.log("IFRAME","not urgente :", item, this.disabledUrgentes);

                      if(this.countPedidos == 1){
                          this.txtUrgentes       = "Enviar urgente!";
                          this.disabledUrgentes  = false;
                      } else {
                        this.disabledUrgentes  = false;
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                      return;
                    }
                  });

                  let maxEnviados  = 0;
                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "enviado"){
                      maxEnviados++;
                    }
                  });

                  if(maxEnviados == this.pedidosList.length){
                    this.disableBtn  = true;
                  }
        }else{
          this.disableBtn  = true;
          this.pedidosList = [];
          this.countPedidos = 0;
          console.log("IFRAME","this.disableBtn: ", this.disableBtn);
        }
        this.CalcularCarrito();
      })
  }

  CalcularCarrito(){
      let precioSubtotal = 0;
      let precioTotal = 0;
      if(this.pedidosList.length > 0){
        this.pedidosList.map( (pedido) => {
          if(pedido.Tipo !='pendiente' && pedido.Tipo !='enviado'){
            console.log("IFRAME",pedido);
            precioSubtotal  += parseFloat(pedido.Precio) * parseInt(pedido.Cantidad ? pedido.Cantidad : pedido.cantidad);
            precioTotal     += parseFloat(pedido.Precio_Iva) * parseInt(pedido.Cantidad ? pedido.Cantidad : pedido.cantidad);
            if(isNaN(precioSubtotal) || isNaN(precioTotal)){
              setTimeout(()=>{
                this.CalcularCarrito();
              },500);
            }else{
              this.precioSubtotal = precioSubtotal.toFixed(2);
              this.precioTotal = precioTotal.toFixed(2);
            }
          } 
        })
      }else{
        this.precioSubtotal = "";
        this.precioTotal = "";
        this.sinOrdenar = false;
      }
  }
  EliminarCarrito(pedido){
    if(this.pedidosList.length > 0){
      this.pedidosList.map( (ped,ind) => {
        if(pedido.Id == ped.Id){
          this.pedidosList.splice(ind,1);
          this.CalcularCarrito();
        } 
      })
    }
  }
  ResetearPedido(){
    this.ordenarPedido = {
      Id_Cliente:0,
      Tipo:"",
      Total:"",
      Subtotal:"",
      Observacion:"",
      ComprobantePago:"",
      Id_Pago:"",
      Id_Customer:false
    }
  }
  bestSeller(){
    console.log("IFRAME","show pedido: ");
    // this.stopCamera();
    this.isTransparent = false;

    // CHANGE STATE
    this.showBestSellerMenu = true;
    this.showMenu           = false;
    this.showPayment        = false;
    this.imagenComprobante  = null;
    let API = this.API;
    console.log("IFRAME","login: ", this.nameItem, this.passwordItem);

    // if(localStorage.getItem("showModal") != "show"){
    //   const alert = this.alertCtrl.create({
    //     title: 'Atención',
    //     message: 'Artículos con precios finales sin IVA.'
    //   });
    //   alert.present();
    //   setTimeout( ()=> {
    //     alert.dismiss();
    //     localStorage.setItem("showModal", "show");
    //   },2000);
    // }

    this.http.get(API + 'productos-populares.php').subscribe( (res) => {
      console.log("IFRAME","response pedidos: ", res.json() );
      // this.bestProducts = [];
      if(res.json().response && this.bestProducts.length == 0){
        // this.bestProducts = res.json().response;
        this.bestProducts    = res.json().colecciones;
      }
    })
  }

  BuildYearsSelect(){
    let year = new Date().getFullYear();
    let lastYear = year + 10;
    for(var i = 0; i <= 10;i++){
      this.arrYears.push(year+i);
    }
  }

  backToColection(){
    this.location = 'colecciones';
    this.showPedidosContainer = false;
    this.showPedidosPendientes= false;
    this.loginSuccess         = false;
    this.loginStart           = false;
    this.showBestSeller       = false;
    this.isTransparent        = false;

    this.showMenu             = false;
    this.showPayment          = false;
    this.pagoTarjeta          = false;
    this.showBestSellerMenu   = true;
    this.imagenComprobante    = null;

    if(this.bestProducts.length == 0){
      this.bestSeller();
    }
  }

  selectColection(colection){
    this.showBestSellerMenu = false;
    this.showMenu           = false;
    this.showPayment        = false;
    this.imagenComprobante  = null;
    this.showBestSeller     = true;

    this.webProducts        = colection;
    this.brandIndicator     = colection.marca;

    //console.log("IFRAME","this.webProducts: ", this.webProducts);
    console.log("IFRAME",this.pedidosList);
    this.webProducts.productos.map( (item) => {
      var sendStatus = false;
      item.cantidad = 1;
      this.pedidosList.map( (ped) => {
        //console.log("IFRAME","ped: ", ped, "item: ", item);
        if(ped.Foto == item.Path && ped.Tipo != 'enviado' && ped.IdPedidosOrdenApp == null){
          console.log("IFRAME","ped: ", ped, "item: ", item);
          item.thisPedido = true;
          sendStatus = true;
          item.cantidad = ped.Cantidad ? ped.Cantidad : ped.cantidad;
          item.Id_Pedido = ped.Id;
        }
      })
      if(!sendStatus){
        item.thisPedido = false;
      }
    })

    console.log("IFRAME","this colection : ", colection);
  }

  VerificarPassword(){
    setInterval(()=>{
      if(this.loginStart  == false){
        let API = this.API;
        if(localStorage.getItem("userEmail") && localStorage.getItem("userPassword")){
          if(this.loginStart == false){
            this.http.post(API + 'verificarPassword.php', {email: localStorage.getItem("userEmail"), password: localStorage.getItem("userPassword")}).subscribe( (res) => {
              if(res.json().response){
                console.log("IFRAME","Credenciales verificadas");
              }else{
                this.CerrarSession();
              }
            });
          }
        }
      }
    },600000);
  }

  CerrarSession(){
    this.ResetearPago();
    this.ResetearPedido();
    localStorage.clear();
    this.arrayInstallments    = [];
    this.paymentData.add_card   = false;
    this.paymentData.cardId   = false;
    this.paymentData.Id_Customer = false;
    this.loginSuccess         = false;
    this.loginStart           = true;
    this.showPedidosContainer = false;
    this.showPedidosPendientes= false;
    this.showBestSeller       = false;
    this.showMenu             = false;
    this.showPayment          = false;
    // this.stopCamera();
    this.isTransparent = false;
  }

  closeSession(){
    const confirm = this.alertCtrl.create({
      title: 'Atención',
      message: '¿Está seguro que desea cerrar sesión?',
      buttons: [
        {
          text: 'NO',
          handler: () => {
            console.log("IFRAME","volver ::");
          }
        },
        {
          text: 'SI',
          handler: () => {
            this.ResetearPago();
            this.ResetearPedido();
            localStorage.clear();
            this.arrayInstallments    = [];
            this.paymentData.add_card   = false;
            this.paymentData.cardId   = false;
            this.paymentData.Id_Customer = false;
            this.loginSuccess         = false;
            this.loginStart           = true;
            this.showPedidosContainer = false;
            this.showPedidosPendientes= false;
            this.showBestSeller       = false;
            this.showMenu             = false;
            this.showPayment          = false;
            // this.stopCamera();
            this.isTransparent = false;
          }
        }
      ]
    });
    confirm.present();
  }

  backCam(){
    this.showPedidosContainer = false;
    this.showPedidosPendientes= false;
    this.loginSuccess         = true;
    this.loginStart           = false;
    this.showMenu             = false;
    this.showPayment          = false;
    this.showBestSeller       = false;
    this.showBestSellerMenu   = false;
    this.reset();
  }

  menuDisplay(){
    this.showPedidosContainer = false;
    this.showPedidosPendientes= false;
    this.loginSuccess         = false;
    this.loginStart           = false;
    this.showMenu             = true;
    this.showPayment          = false;
    this.showBestSellerMenu   = false;
    this.showBestSeller       = false;
    this.isTransparent        = false;
    this.hideCam = true;
  }

  menuClose(){
    this.showMenu  = false;
    this.backCam();
  }

  takePhoto() {
    let tablet = this.isTablet;
    // FAKE FOTO
    let API = this.API;
    this.pictureTaken     = false;
    this.isTransparent    = false;
    this.waitCam          = false;
    this.picture          = "";
    this.cantidad         = "1";

    console.log("IFRAME","sizes: ", this.getSizes());

    console.log("IFRAME","pickture taken: ", this.pictureTaken);
    this.cameraPreview.takePicture(this.pictureOpts).then(
      (imageData) => {
        this.isTransparent = false;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");
        var image = new Image();
        image.onload = function() {
          console.log("IFRAME",'image is ' + image.width + 'x' + image.height);
          canvas.width = image.width;
          canvas.height = image.height*0.4;
          ctx.drawImage(image,0,0,window.screen.width, window.screen.width*4/3);
        }.bind(this);
        this.picture       = 'data:image/png;base64,' + imageData;
        image.src          = 'data:image/png;base64,' + imageData;
        this.pictureTaken  = true;
        this.waitCam       = false;
        this.stopCamera();
        this.isTransparent = false;
      },
      (err) => {
        console.log("IFRAME",err);
        this.pictureTaken   = false;
        this.waitCam        = false;
      });
      
      // EXAMPLE TO UNCOMMENT
      // this.http.post(this.POOL + 'pool.php', {img_encoded: this.imageExample}).subscribe( (res) => {
      //   console.log("IFRAME","imageExample: ", res.json() );
      //   this.picture      = this.imageExample;
      //   this.pictureTaken = true;
      //   this.waitCam      = false;
      // })
  }


  pedir(){
    this.sendPedido.id       = this.id;
    this.sendPedido.cantidad = this.cantidad;
    this.sendPedido.foto     = this.picture ? this.picture : this.imageExample;
    this.waitCam             = true;
    this.disabledUrgentes    = false;
    // console.log("IFRAME","obj pedido: ", this.sendPedido, this.imageExample);

    let API = this.API;

    this.http.post(this.POOL + 'pool.php', {img_encoded: this.picture }).subscribe( (r) => {
      console.log("IFRAME","imageExample: ", r.json() );
      this.sendPedido.foto  = r.json().url;

      this.http.post(API + 'pedido.php', this.sendPedido).subscribe( (res) => {
        console.log("IFRAME","pedido log: ", res.json() );
        this.CountPedidos(res.json().response);
        this.pedidosList    = res.json().response;
        this.pictureTaken   = false;
        this.waitCam        = false;

        const confirm = this.emitModal({
          title: 'Pedido realizado!',
          message: 'Se enviarán cuando compra alcance U$D 100',
          dismiss: 4000,
        });
        this.reset();
      })

    })

    
  }

  CantidadSumar(pedido){
    console.log("IFRAME",pedido);
    if(!pedido.Cantidad && !pedido.Marca){
      if(!pedido.cantidad){
        pedido.cantidad = 1;
      }else{
        pedido.cantidad += 1;
      }
      if(pedido.Id_Pedido){
        this.countPedidos += 1; 
        this.updateCantidadPedido({"Id":pedido.Id_Pedido,"Cantidad":pedido.cantidad});
      }else{
        this.CalcularCarrito();
      }
      
    }else if(!pedido.Marca){
      if(!pedido.Cantidad){
        pedido.Cantidad = 1;
      }else{
        pedido.Cantidad += 1;
      }
      this.countPedidos += 1;
      this.updateCantidadPedido(pedido);
      this.CalcularCarrito();
    }
    if(pedido.Marca && pedido.thisPedido){
      if(!pedido.cantidad){
        pedido.cantidad = 1;
      }else{
        pedido.cantidad += 1;
      }
      this.countPedidos += 1;
      this.findPedidoAndUpdate(pedido);
    }else if(pedido.Marca){
      if(!pedido.cantidad){
        pedido.cantidad = 1;
      }else{
        pedido.cantidad += 1;
      }
    }
  }
  CantidadaRestar(pedido){
    var tempCantidad = pedido.cantidad; 
    if(!pedido.Cantidad && !pedido.Marca){
      if(!pedido.cantidad || pedido.cantidad < 1){
        pedido.cantidad = 1;
      }else if(pedido.cantidad > 1){
        pedido.cantidad -= 1;
      }
      if(pedido.Id_Pedido){
        if(pedido.cantidad > 1){
          this.countPedidos -= 1; 
        }
        this.updateCantidadPedido({"Id":pedido.Id_Pedido,"Cantidad":pedido.cantidad});
      }else{
        this.CalcularCarrito();
      }
    }else if(!pedido.Marca){
      if(!pedido.Cantidad || pedido.Cantidad < 1){
        pedido.Cantidad = 1;
      }else if(pedido.Cantidad > 1){
        pedido.Cantidad -= 1;
      }
      if(pedido.Cantidad > 1){
        this.countPedidos -= 1;
      }
      this.updateCantidadPedido(pedido);
      this.CalcularCarrito();
    }
    if(pedido.Marca && pedido.thisPedido){
      if(!pedido.cantidad || pedido.cantidad < 1){
        pedido.cantidad = 1;
      }else if(pedido.cantidad > 1){
        pedido.cantidad -= 1;
        this.countPedidos -= 1;
      }
      this.findPedidoAndUpdate(pedido);
    }else if(pedido.Marca){
      if(!pedido.cantidad || pedido.cantidad < 1){
        pedido.cantidad = 1;
      }else if(pedido.cantidad > 1){
        pedido.cantidad -= 1;
      }
    }
  }

  updateCantidadPedido(pedido){
    let API = this.API;
    this.http.post(API + 'update-cantidad-pedido.php', pedido).subscribe( (res) => {
      console.log("IFRAME","cantidad update log: ", res.json() );
    })
  } 
  findPedidoAndUpdate(pedido){
    let API = this.API;
    this.pedidosList.map((pedidoList)=>{
      if(pedido.Path == pedidoList.Foto){
        console.log("IFRAME","UPDATE PEDIDO::",pedidoList);
        pedidoList.Cantidad = pedido.cantidad;
        this.http.post(API + 'update-cantidad-pedido.php', pedidoList).subscribe( (res) => {
          console.log("IFRAME","cantidad update log: ", res.json() );
        })
      }
    })
  }
  pedirProducto(pedido, foto){
    console.log("IFRAME","path: foto", foto);
    this.sendPedido.id       = this.id;
    this.sendPedido.cantidad = pedido.cantidad ? pedido.cantidad : this.cantidad;
    this.sendPedido.foto     = foto;
    console.log("IFRAME","obj pedido: ", this.sendPedido);
    let API = this.API;
    
    this.disabledUrgentes = false;
    pedido.thisPedido   = true;
    this.countPedidos += parseFloat(this.sendPedido.cantidad);
    this.http.post(API + 'pedido.php', this.sendPedido).subscribe( (res) => {
      console.log("IFRAME","pedido log: ", res.json() );
      this.CountPedidos(res.json().response);
      this.pedidosList    = res.json().response;
      this.pictureTaken   = false;
      if(!res.json().response){
        pedido.thisPedido   = false;
      }
      // const alert = this.alertCtrl.create({
      //   title: 'Confirmación',
      //   message: 'Se ha agregado al carrito!'
      // });
      // alert.present();
      // setTimeout(()=>alert.dismiss(),2000);
       // this.reset();
    })
  }

  eliminarPedido(pedido,ind){
    console.log("IFRAME","the pedido: ", pedido);
    this.modalPedido = pedido;
    this.modalInd = ind;
    const confirm = this.alertCtrl.create({
          title: 'Atención',
          message: '¿Desea eliminar este artículo?',
          buttons: [
        {
          text: 'NO',
          handler: () => {
            console.log("IFRAME","volver ::");
          }
        },
        {
          text: 'SI',
          handler: () => {
              this.confirmarModalEliminar();
          }
        }
      ]
    });
    confirm.present();
    // this.modal_show = true;
    // this.modal_fade = true;
    // this.modal_hiding = false;
  };

  cerrarModalEliminar(){
    this.modalPedido = {};
    this.modalInd = {};
    this.modal_fade = true;
    this.modal_hiding = true;
    this.modal_show = false;

    setTimeout(() => {
      this.modal_fade = false;
      this.modal_hiding = false;
      this.modal_show = false;
    }, 100);
  }

  confirmarModalEliminar(){
    this.sendDelete = true;
    const pedido = this.modalPedido;
    const ind = this.modalInd;

    console.log("IFRAME","this.bestProducts: ", this.bestProducts);
    this.EliminarCarrito(pedido);
    let API = this.API;
    this.http.post(API + 'pedido-eliminar.php', pedido).subscribe( (res) => {
      console.log("IFRAME","pedido log: ", res.json() );
      this.pedidosList.splice(ind, 1);
      this.CountPedidos(this.pedidosList);

      // IF PATH IS THE SAME THEN DISABLE PRODUCT OF BEST PRODUCTS
      for (var i = this.bestProducts.length - 1; i >= 0; i--) {
        let foto = pedido.foto ? pedido.foto : pedido.Foto;

        for (var j = this.bestProducts[i].productos.length - 1; j >= 0; j--) {
          if(this.bestProducts[i].productos[j].Path == foto){
            this.bestProducts[i].productos[j].thisPedido = false;
          }
        }
        
      }

      setTimeout(()=>{
        this.sendDelete = false;
      },500);
    })

  }

  salirOrdenModal(){
    this.modal_fade_orden = true;
    this.modal_hiding_orden = true;
    this.modal_show_orden = false;
    this.isTransparent = false;
    this.pictureTaken = false;
    this.waitCam      = true;
    setTimeout(() => {
      this.modal_fade_orden = false;
      this.modal_hiding_orden = false;
      this.modal_show_orden = false;
      this.isTransparent = false;
      this.pictureTaken = false;
      this.waitCam      = true;
    }, 100);
  }

  confirmarModal(){
    setTimeout(()=>{
        this.cerrarModal();
      },500);
  }

  cerrarModal(){
    this.modal_title = '';
    this.modal_content = '';
    this.modal_fade_pedido = true;
    this.modal_hiding_pedido = true;
    this.modal_show_pedido = false;

    setTimeout(() => {
      this.modal_fade_pedido = false;
      this.modal_hiding_pedido = false;
      this.modal_show_pedido = false;
    }, 100);
  }

  pedirUrgente(){
    this.sendPedido.id       = this.id;
    this.sendPedido.cantidad = this.cantidad;
    this.sendPedido.foto     = this.picture;
    this.sendPedido.tipo     = "urgente";

    console.log("IFRAME","obj pedido: ", this.sendPedido);

    let API       = this.API;
    let MAIL_API  = this.MAIL_API;

    const confirm = this.alertCtrl.create({
      title: 'Atención',
      message: 'Pedido urgente menores a USD 100 flete a cargo de la Óptica.',
      buttons: [
        {
          text: 'Volver',
          handler: () => {
            console.log("IFRAME","volver ::");
            this.sendPedido.tipo     = "comun";
          }
        },
        {
          text: 'OK',
          handler: () => {
          
          this.waitCam  = true;

          this.http.post(this.POOL + 'pool.php', {img_encoded: this.picture }).subscribe( (r) => {
            console.log("IFRAME","imageExample: ", r.json() );
            this.sendPedido.foto  = r.json().url;
              
              this.http.post(API + 'pedido.php', this.sendPedido).subscribe( (res) => {
                console.log("IFRAME","pedido log: ", res.json() );
                console.log("IFRAME","Pedir Urgente");
                this.CountPedidos(res.json().response);
                this.pedidosList    = res.json().response;
                this.pictureTaken   = false;
                this.waitCam        = false;

                let urgentMailBody  = {
                    "site_title": "Pedido urgente! APP Eyewear Uruguay",
                    "topic": "Pedido urgente! APP Eyewear Uruguay",
                    "to_email": this.toEmail,
                    "headers": {
                        "from_email": "app@eyewearuruguay.com",
                        "bcc_emails": "alex@lexartlabs.com"
                    },
                    "body": (this.nombreCliente ? this.nombreCliente : this.fantasiaCliente) + ", pedido Urgente."
                };

                // SEND EMAIL IN BACKGROUND
                this.http.post(MAIL_API, urgentMailBody).subscribe( (res) => {
                  console.log("IFRAME","sent email body ::", res.json());
                })


                this.sendPedido.tipo  = "comun";

                const confirm = this.emitModal({
                  title: 'Confirmación',
                  message: 'Pedido urgente realizado!',
                  dismiss: 2000,
                });
                this.reset();
              })
            })
          }
        }
      ]
    });
    confirm.present();
  }

  proceedPayment(){
    if(parseInt(this.precioSubtotal) < 100){
      const confirm = this.alertCtrl.create({
      title: 'Atención',
      message: 'Pedidos menores a USD 100 flete a cargo de la Óptica.',
      buttons: [
        {
          text: 'Volver',
          handler: () => {
            console.log("IFRAME","volver ::");
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.showPedidosContainer = false;
            this.showPedidosPendientes= false;
            this.loginSuccess         = false;
            this.loginStart           = false;
            this.showBestSeller       = false;
            this.isTransparent        = false;
            this.pictureTaken         = false;
            this.showMenu             = false;
            this.showBestSellerMenu   = false;
            this.waitCam              = true; 
            this.showPayment          = true;
            this.imagenComprobante = null;
            this.adjuntarComprobante = false;
            this.pagoTarjeta         = false;
            this.viewSelectCuotas      = false;
            this.location = 'payment';
          }
        }
      ]
    });
    confirm.present();
    }else{
      this.showPedidosContainer = false;
      this.showPedidosPendientes= false;
      this.loginSuccess         = false;
      this.loginStart           = false;
      this.showBestSeller       = false;
      this.isTransparent        = false;
      this.pictureTaken         = false;
      this.showMenu             = false;
      this.showBestSellerMenu   = false;
      this.waitCam              = true; 
      this.showPayment          = true;
      this.imagenComprobante = null;
      this.adjuntarComprobante = false;
      this.pagoTarjeta         = false;
      this.viewSelectCuotas      = false;
      this.location = 'payment';
    }
  }

  backProceedPayment(){
    this.showPedidosContainer = false;
    this.showPedidosPendientes= false;
    this.loginSuccess         = false;
    this.loginStart           = false;
    this.showBestSeller       = false;
    this.isTransparent        = false;
    this.pictureTaken         = false;
    this.showMenu             = false;
    this.showBestSellerMenu   = false;
    this.waitCam              = true; 
    this.showPayment          = true;
    this.imagenComprobante = null;
    this.adjuntarComprobante = false;
    this.pagoTarjeta         = false;
    this.viewSelectCuotas      = false;
    this.location = 'payment';
  }

  switchPendientes(){
    this.showPedidosContainer = false;
    this.loginSuccess         = false;
    this.loginStart           = false;
    this.showBestSeller       = false;
    this.isTransparent        = false;
    this.pictureTaken         = false;
    this.showMenu             = false;
    this.showBestSellerMenu   = false;
    this.waitCam              = true; 
    this.showPayment          = false;
    this.imagenComprobante = null;
    this.adjuntarComprobante = false;
    this.pagoTarjeta         = false;
    this.viewSelectCuotas      = false;
    if(this.showPedidosPendientes){
      this.showPedidosPendientes = false;
      this.showPedidosContainer  = true;
    }else{
      this.showPedidosPendientes = true;
      this.showPedidosContainer  = false;
      if(this.pedidosList.length == 0){
        const confirm = this.alertCtrl.create({
          title: 'Atención',
          message: 'No hay artículos pendientes de envío',
        });
        confirm.present();
        setTimeout(()=>confirm.dismiss(),2500);
        this.disabledUrgentes    = true;
      }
    }
    this.location = 'payment';
  }

  creditCard(){
    console.log("IFRAME","PAGO TARJETA CRÉDITO");
    this.adjuntarComprobante = false;
    this.waitCam              = true;
    this.showPayment         = false;
    this.isTransparent        = false;
    this.pictureTaken         = false;
    this.imagenComprobante = null;
    this.tipoPayment = "tarjeta";
    this.pagoTarjeta         = true;
    this.tipoTarjeta.credito = true;
    this.tipoTarjeta.debito  = false;
    this.viewTarjetaTitle = "Tarjeta de crédito";
    this.viewSelectCuotas = false;
    this.ResetearPago();
    this.resetPagoMarkField();
    this.paymentData.add_card = true;
  }
  debitCard(){
    console.log("IFRAME","PAGO TARJETA DÉBITO");
    this.adjuntarComprobante = false;
    this.waitCam              = true;
    this.showPayment         = false;
    this.isTransparent        = false;
    this.pictureTaken         = false;
    this.imagenComprobante = null;
    this.tipoPayment = "tarjeta";
    this.pagoTarjeta         = true;
    this.tipoTarjeta.credito = false;
    this.tipoTarjeta.debito  = true;
    this.viewTarjetaTitle = "Tarjeta de débito";
    this.viewSelectCuotas = false;
    this.ResetearPago();
    this.resetPagoMarkField();
    this.paymentData.add_card = true;
  }

  selectCard(tarjeta){
    console.log("IFRAME","PAGO TARJETA EXISTE");
    this.adjuntarComprobante = false;
    this.waitCam              = true;
    this.showPayment         = false;
    this.isTransparent        = false;
    this.pictureTaken         = false;
    this.imagenComprobante = null;
    this.tipoPayment = "tarjeta";
    this.ResetearPago();
    this.resetPagoMarkField();
    this.paymentData.cardId = tarjeta.id;
    this.paymentData.cardExpirationMonth = tarjeta.expiration_month;
    this.paymentData.cardExpirationYear = tarjeta.expiration_year;
    this.tarjetaSeisDigitos = tarjeta.first_six_digits;
    this.guessingPaymentMethod();
    this.viewSelectCuotas = true;
    if(tarjeta.payment_method.payment_type_id == "credit_card"){
      this.pagoTarjeta         = false;
      this.tipoTarjeta.credito = true;
      this.tipoTarjeta.debito  = false;
      this.tieneTarjeta        = true;
      this.viewTarjetaTitle = "Tarjeta de crédito";
    }else if(tarjeta.payment_method.payment_type_id == "debit_card"){
      this.pagoTarjeta         = false;
      this.tipoTarjeta.credito = false;
      this.tipoTarjeta.debito  = true;
      this.tieneTarjeta        = true;
      this.viewTarjetaTitle = "Tarjeta de débito";
    }
  }

  selectedCuotas(installment){
    this.paymentData.installments = installment.installments;
    this.pagoTarjeta = true;
    this.viewSelectCuotas = false;
  }

  bankTransfer(){
    this.adjuntarComprobante = true;
    this.pagoTarjeta         = false;
    this.viewSelectCuotas      = false;
    this.tipoPayment = "transferencia";
  }

  subirComprobante(e){
    this.imagenComprobante = null;
    this.isTransparent = true;
    this.pictureTaken = false;
    this.startCamera();
  }

  paymentCamaraExit(){
      const confirm = this.alertCtrl.create({
          title: 'Atención',
          message: 'Sin comprobante de pago, no se enviará el pedido.',
          buttons: [
        {
          text: 'OK',
          handler: () => {
            console.log("IFRAME","volver ::");
          }
        },
        {
          text: 'VOLVER',
          handler: () => {
            this.adjuntarComprobante = false;
          }
        },
      ]
    });
    confirm.present();
  }

  ordenar(){

    this.http.post(this.POOL + 'pool.php', {img_encoded: this.picture }).subscribe( (r) => {
      console.log("IFRAME","imageExample: ", r.json() );
      this.sendPedido.foto  = r.json().url;
      this.ordenarPedido.Id_Cliente   = this.id;
      this.ordenarPedido.Tipo   = this.tipoPayment;
      this.ordenarPedido.Total   = this.precioTotal;
      this.ordenarPedido.Subtotal   = this.precioSubtotal;
      this.ordenarPedido.Observacion   = "";
      this.ordenarPedido.ComprobantePago   = this.sendPedido.foto;
      let API = this.API;
      this.http.post(API + 'pedido-order.php', this.ordenarPedido).subscribe( (res) => {
        console.log("IFRAME","Orden log: ", res.json() );
        if(res.json().response == true){
          this.isTransparent = false;
          this.pictureTaken = false;
          this.waitCam      = false;
          this.picture          = "";
          this.location = 'showPedidos';
          this.showPedidos();
          this.ResetearPedido();
          this.emitModal({
            title: 'Comprobante enviado!',
            message: 'No hay artículos pendientes de envío',
            dismiss: 4000,
          });
          this.reset();
        }else{
          this.isTransparent = false;
          this.pictureTaken = false;
          this.waitCam      = false;
          this.emitModal({
            title: 'Error',
            message: 'El pedido no enviado ordenar ' + "\n" + JSON.stringify(res.json()),
            dismiss: 4000,
          });
          this.reset();
        }
      })

    })
  }

  orderList(list){
    list.sort((a,b) =>{
      if ( a.Id < b.Id ){
        return -1;
      }
      if ( a.Id > b.Id ){
        return 1;
      }
      return 0;
    });
    return list;
  }

  cancelPedido(pedido){
    pedido.id_cliente = this.id;
    pedido.type       = "static";
    pedido.foto       = pedido.Path;
    pedido.cantidad   = 1;
    const confirm = this.alertCtrl.create({
      title: 'Atención',
      message: '¿Está seguro que desea cancelar este pedido?',
      buttons: [
        {
          text: 'NO',
          handler: () => {
            console.log("IFRAME","volver ::");
          }
        },
        {
          text: 'SI',
          handler: () => {
              pedido.thisPedido = false;

              let API = this.API;
              this.http.post(API + 'pedido-eliminar.php', pedido).subscribe( (res) => {
                console.log("IFRAME","pedido log: ", res.json() );
                this.pedidosList    = res.json().response;
                console.log("IFRAME","Cancelar Pedido");
                this.CountPedidos(this.pedidosList);

                const confirm = this.alertCtrl.create({
                  title: 'Confirmación',
                  message: 'Pedido cancelado',
                });
                confirm.present();
                setTimeout(()=>confirm.dismiss(),2000);
              })
          }
        }
      ]
    });
    confirm.present();
  }

  enviarTodosUrgentes(){
    this.disabledUrgentes = true;

    console.log("IFRAME","enviar pedidos urgentes");
    let API = this.API;

    const confirm = this.alertCtrl.create({
      title: 'Atención',
      message: 'Pedido urgente menores a USD 100 flete a cargo de la Óptica.',
      buttons: [
        {
          text: 'Volver',
          handler: () => {
            console.log("IFRAME","volver ::");
            this.disabledUrgentes = false;
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.http.post(API + 'update-pedidos.php', this.pedidosList).subscribe( (res) => {
              console.log("IFRAME","pedidosList send log: ", res.json() );
              // this.countPedidos   = 0;
              this.txtUrgentes = "Envío urgente confirmado!";
              if(res.json().response){
                // this.pedidosList = res.json().response;

                let urgentMailBody  = {
                    "site_title": "Pedido urgente! APP Eyewear Uruguay",
                    "topic": "Pedido urgente! APP Eyewear Uruguay",
                    "to_email": this.toEmail,
                    "headers": {
                        "from_email": "app@eyewearuruguay.com",
                        "bcc_emails": "alex@lexartlabs.com"
                    },
                    "body": (this.nombreCliente ? this.nombreCliente : this.fantasiaCliente) + ", pedido Urgente."
                };

                // SEND EMAIL IN BACKGROUND
                this.http.post(this.MAIL_API, urgentMailBody).subscribe( (res) => {
                  console.log("IFRAME","sent email body ::", res.json());
                })
              }

              // const alert = this.alertCtrl.create({
              //   title: 'Confirmación',
              //   message: 'Pedido realizado!'
              // });
              // alert.present();
              // setTimeout(()=>alert.dismiss(),2000);
            })
          }
        }
      ]
    });
    confirm.present();
  }

  solicitarVisita(){
    let API = this.API;
    if(this.checkVisit == true){

      this.checkVisit = false;
      this.http.post(API + 'agendar-visita.php', {id: this.id, visita: 0, cliente: this.nombreCliente}).subscribe( (res) => {
        console.log("IFRAME","visita: ", res.json() );

        let urgentMailBody  = {
              "site_title": "Cancelar visita. APP Eyewear Uruguay",
              "topic": "Cancelar visita. APP Eyewear Uruguay",
              "to_email": this.toEmail,
              "headers": {
                  "from_email": "app@eyewearuruguay.com",
                  "bcc_emails": "josue.eyewear@gmail.com"
              },
              "body": "Visita cancelada por: " + (this.nombreCliente ? this.nombreCliente : this.fantasiaCliente)
          };

          // SEND EMAIL IN BACKGROUND
          this.http.post(this.MAIL_API, urgentMailBody).subscribe( (res) => {
            console.log("IFRAME","sent email body ::", res.json());
          })

        const confirm = this.alertCtrl.create({
          title: 'Información',
          message: 'Solicitud cancelada.',
        });
        confirm.present();
        setTimeout(()=>confirm.dismiss(),2000);
      })
    } else {
      this.visitDate  = Date();

      console.log("IFRAME","visit date : ", this.visitDate);

      this.checkVisit = true;
      this.http.post(API + 'agendar-visita.php', {id: this.id, visita: 1, cliente: this.nombreCliente}).subscribe( (res) => {
        console.log("IFRAME","visita: ", res.json() );

        let urgentMailBody  = {
              "site_title": "Agendar visita. APP Eyewear Uruguay",
              "topic": "Agendar visita. APP Eyewear Uruguay",
              "to_email": this.toEmail,
              "headers": {
                  "from_email": "app@eyewearuruguay.com",
                  "bcc_emails": "josue.eyewear@gmail.com"
              },
              "body": "Visita solicitada por: " + (this.nombreCliente ? this.nombreCliente : this.fantasiaCliente)
          };

          // SEND EMAIL IN BACKGROUND
          this.http.post(this.MAIL_API, urgentMailBody).subscribe( (res) => {
            console.log("IFRAME","sent email body ::", res.json());
          })

        const confirm = this.alertCtrl.create({
          title: 'Confirmación',
          message: 'Visita solicitada',
        });
        confirm.present();
        setTimeout(()=>confirm.dismiss(),2000);
      })
    }
  }

  reset() {
    this.isTransparent = true;
    this.pictureTaken = false;
    this.startCamera();
  }

  checkDate(date){
    const oneday             = 60 * 60 * 24 * 1000;
    const now: any          = new Date();
    const thisDate: any     = new Date(date);
    
    return (now - thisDate) > (oneday * 3);
  }

  GetDolar(){
    this.http.get('https://api.lexart.com.uy/gp-beta/algorithm/scrap/ine.php').subscribe( (rz) => {
      const dolar     = rz.json();
      this.usd = dolar.dolar.sell;
      console.log(this.usd);
    })
  }

  ionViewDidEnter() {
    this.VerificarPassword();
    this.BuildYearsSelect();
    //this.GetDolar();
    // this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY);
    let theSeconds = 5000;

    function compareJSON(obj1, obj2) { 
      var ret = {}; 
      for(var i in obj2) { 
        if(!obj1.hasOwnProperty(i) || obj2[i] !== obj1[i]) { 
          ret[i] = obj2[i]; 
        } 
      } 
      return ret; 
    }; 

    // IF LOGALSTORAGE IS SETED
    if(localStorage.getItem("userEmail") && localStorage.getItem("userPassword")){
      let API = this.API;
      console.log("IFRAME","login: ", this.nameItem, this.passwordItem);
      this.loginSuccess = true;
      this.loginStart   = false;
      

      this.http.post(API + 'login.php', {email: localStorage.getItem("userEmail"), password: localStorage.getItem("userPassword")}).subscribe( (res) => {
        console.log("IFRAME","hola: ", res.json() );
        if(res.json().response){
          this.visitaApi    = res.json().response.visita;

          if(this.visitaApi.Visita == "1"){
            this.checkVisit = true;
            this.visitDate  = new Date(this.visitaApi.Fecha_Visita);
            this.visitDate.setDate(this.visitDate.getDate() + 1);
          }

          this.loginSuccess = true;
          this.loginStart = false;
          console.log("IFRAME","Login Count");
          this.CountPedidos(res.json().response.pedidos);
          this.id           = res.json().response.id;
          this.pedidosList  = res.json().response.pedidos;
          this.nombreCliente= res.json().response.nombre;
          this.fantasiaCliente = res.json().response.fantasia;

          localStorage.setItem("userEmail", res.json().response.email);
          localStorage.setItem("userPassword", res.json().response.contrasena);
          localStorage.setItem("pedidoJSON", JSON.stringify(this.pedidosList));

          if(this.loginSuccess){
            this.ClienteCustomerId();
            // SET UP - POLLER APP
            /*
            setInterval( () => {
              // console.log("IFRAME","run poller ::");
              // console.log("IFRAME","run poller ::");
              this.http.get(API + 'descuento-app.php').subscribe( (rz) => {
                let descuento     = rz.json().response.descuento;
                let descuentoCol  = rz.json().response.descuentoCol;
                let descuentoDeudor  = rz.json().response.descuentoDeudor;

                if(this.descuento != descuento || 
                  this.descuentoCol != descuentoCol || 
                  this.descuentoDeudor != descuentoDeudor){
                  
                  console.log("IFRAME","try distinct ::");
                  this.descuento     = descuento;
                  this.descuentoCol  = descuentoCol;
                  this.descuentoDeudor = descuentoDeudor;
                }
              })
              this.http.get(API + 'pedidos.php?idCliente=' + this.id).subscribe( (rx) => {
                this.sinOrdenar = rx.json().sinOrdenar;

                if(rx.json().ordenes){
                  if(this.ordenList && this.ordenList.length > 0 ){
                    if(rx.json().ordenes.length > 0){
                      rx.json().ordenes.map((orden)=>{
                        var exist = false;
                        this.ordenList.map((ordenMob)=>{
                          if(orden.Id == ordenMob.Id){
                            exist = true;
                          }
                        });
                        if(!exist){
                          this.ordenList.push(orden);
                        }
                      });
                    }
                  }else{
                    this.ordenList = rx.json().ordenes;
                  }
                }

                if(rx.json().response){
                  console.log("IFRAME","Login Count 2");
                  this.CountPedidos(rx.json().response);



                  let isIn        = false;
                  let maxUrgentes = 0;
                  let precioSubtotal = 0;
                  let precioTotal = 0;

                  if(this.pedidosList.length > 0){
                    if(rx.json().response.length > 0){
                      this.disableBtn  = false;
                      rx.json().response.map( (pedido) => {
                        var pedidoExist = false;
                        this.pedidosList.map( (pedMob) => {
                          if(pedido.Id == pedMob.Id){
                            pedidoExist             = true;
                            pedMob.Borrado          = pedido.Borrado;
                            pedMob.Tipo             = pedido.Tipo;
                            pedMob.Precio           = pedido.Precio;
                            pedMob.Precio_Anterior  = pedido.Precio_Anterior;
                            pedMob.Precio_Iva       = pedido.Precio_Iva;
                            pedMob.Descuento        = pedido.Descuento ? pedido.Descuento : null;
                            pedMob.Nuevo            = pedido.Productos ? pedido.Productos.Nuevo : null;
                            pedMob.Cantidad         = pedido.Cantidad ? parseInt(pedido.Cantidad) : 1;
                            if(pedido.IdPedidosOrdenApp){
                              pedMob.IdPedidosOrdenApp = pedido.IdPedidosOrdenApp;
                            }
                            // if(pedido.Tipo !='pendiente' && pedido.Tipo !='enviado'){
                            //   precioSubtotal  += parseFloat(pedido.Precio) * pedMob.Cantidad;
                            //   precioTotal     += parseFloat(pedido.Precio_Iva) * pedMob.Cantidad;
                            //   this.precioSubtotal = precioSubtotal.toFixed(2);
                            //   this.precioTotal = precioTotal.toFixed(2);
                            // } 
                          }
                        })
                        if(!pedidoExist){
                          this.pedidosList.push(pedido);
                        }
                      })

                      // if(rx.json().ordenes.length > 0){
                      //   rx.json().ordenes.map( (orden) => {
                      //     let exist = false;
                      //     this.pedidosList.map( (pedMob) => {
                      //       if(orden.ComprobantePago && orden.ComprobantePago == pedMob.ComprobantePago){
                      //         exist = true;
                      //       }else if(orden.Id_Pago && orden.Id_Pago == pedMob.Id_Pago){
                      //         exist = true;
                      //       }
                      //     })
                      //     if(!exist){
                      //       this.pedidosList.push(orden);
                      //     }
                      //   })
                      // }
                    }else{
                      this.pedidosList = [];
                      this.countPedidos = 0;
                    }
                  } else {
                    this.disableBtn  = true;
                    this.pedidosList = rx.json().response;
                    this.countPedidos = 0;
                  }

                  //console.log("IFRAME","this.disableBtn: ", this.disableBtn);
                  
                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "urgente" || item.Tipo == "enviado"){
                      maxUrgentes++;
                    }
                  });

                  // console.log("IFRAME","count pedidos: ", rx.json().response.length, maxUrgentes);

                  if(maxUrgentes < rx.json().response.length){
                    if(this.countPedidos == 1){
                      if(!this.disabledUrgentes){
                        this.txtUrgentes = "Enviar urgente!";
                      }
                    } else {
                      if(!this.disabledUrgentes){
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                    }
                  } else {
                      // console.log("IFRAME","txt urgente: ", maxUrgentes, rx.json().response.length);
                      this.txtUrgentes = "Envío urgente confirmado!";
                      this.disabledUrgentes = true;
                  }

                  rx.json().response.map( (item) => {
                    // SI EXISTE POR LO MENOS UNO QUE NO SEA
                    // URGENTE
                    // console.log("IFRAME","track item: ", item);
                    if(item.Tipo != "urgente" || item.Tipo == "enviado"){
                      //console.log("IFRAME","not urgente :", item, this.disabledUrgentes);

                      if(this.countPedidos == 1){
                          this.txtUrgentes       = "Enviar urgente!";
                          this.disabledUrgentes  = false;
                      } else {
                        this.disabledUrgentes  = false;
                        this.txtUrgentes   = "Enviar todos urgente!";
                      }
                      return;
                    }
                  });

                  let maxEnviados  = 0;
                  this.pedidosList.map( (item) => {
                    if(item.Tipo == "enviado"){
                      maxEnviados++;
                    }
                  });

                  if(maxEnviados == this.pedidosList.length){
                    this.disableBtn  = true;
                  }

                } else {
                  this.disableBtn  = true;
                  this.pedidosList = [];
                  this.countPedidos = 0;
                  console.log("IFRAME","this.disableBtn: ", this.disableBtn);
                }
              })
            }, theSeconds);*/
          }

          //this.startCamera();
          this.menuDisplay();
        }else{
          this.CerrarSession();
        }
      })
    }
  }
  /* v SOLO PAGOS WEB v */

  //TOMAMOS LOS 6 DIGITOS DE LA TARJETA LOS CUALES SE UTILIZAN COMO IDENTIFICADOR DESDE PAGOS WEB
  getBin(tarjeta){
    this.paymentData.cardNumber = tarjeta;
    var tarjeta = tarjeta.replace(/\s/g, '');
    tarjeta = tarjeta.substring(0,6);
    window.EyewearPagos.tarjetaDigitos = tarjeta;
    return tarjeta;
  };
  VerificarCampoPagos(title,msg,mark){
    const confirm = this.emitModal({
      title: title,
      message: msg,
      dismiss:0,
    });
    if(mark){
      var element = document.querySelector(mark) as HTMLElement;
      element.style.borderColor = "#ff000078";
    }
  }
  VerificarTipoPago(tipo){
    if(tipo){
      if(this.tipoTarjeta.debito && tipo == "credit_card"){
        this.VerificarCampoPagos("Error","La tarjeta ingresada no es de débito",null);
        this.ResetearPago();
      }else if(this.tipoTarjeta.credito && tipo == "debit_card"){
        this.VerificarCampoPagos("Error","La tarjeta ingresada no es de crédito",null);
        this.ResetearPago();
      }
    }
  }
  resetPagoMarkField(){
    var Fields = ["cardNumber","cardNumber","cardholderName","cardExpirationMonth","cardExpirationYear","securityCode","docNumber","email","securityCode"];
    Fields.map(function(field,index){
      var element = document.querySelector("#"+field) as HTMLElement;
      element.style.borderColor = "#969494";
    });
  }
  ResetearPago(){
    this.paymentData.cardNumber="";
    this.paymentData.email="";
    this.paymentData.securityCode="";
    this.paymentData.cardExpirationMonth="";
    this.paymentData.cardExpirationYear="";
    this.paymentData.cardholderName="";
    this.paymentData.docNumber="";
    this.paymentData.issuer_id= "0";
    this.paymentData.amount= 0;
    this.paymentData.installments= 1;
    this.paymentData.description="";
    this.paymentData.paymentMethodId= "";
    this.paymentData.token= "";
    this.paymentData.cardId = false;
    this.paymentData.add_card = false;
    this.paymentData.Id_Pago = false;
    this.tieneTarjeta     = false;
    window.EyewearPagosReset();
    this.tarjetaSeisDigitos = "";
    this.imagenTarjeta = "";
    this.EnableBoton();
    this.arrayInstallments = [];
  }
  FiltrarInstallments(installments,max){
    installments.forEach(function(installment,index){
      if(parseInt(installment.installments) > max){
        installments.splice(index, 1);
      }
    })
    return installments;
  }
  DocumentRemoveChar(){
    this.paymentData.docNumber = this.paymentData.docNumber.replace(/[^\w\s]/gi, '');
  }
  DisabledBoton(){
    console.log("IFRAME", "DisabledBoton");
    this.emitMethod({state: "DisabledBoton"});
    this.disabledButton = true;
  }
  EnableBoton(){
    console.log("IFRAME", "EnableBoton");
    this.emitMethod({state: "EnableBoton"});
    this.disabledButton = false;
  }
  guessingPaymentMethod() {
    this.tarjetaSeisDigitos = this.tarjetaSeisDigitos.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
    window.EyewearPagos.paymentMethodId ="";
    window.EyewearPagos.issuer_id = "";
    window.EyewearPagos.amount = parseFloat(this.precioTotal);
    this.paymentData.amount = parseFloat(this.precioTotal);
    window.guessingPaymentMethod(this.getBin(this.tarjetaSeisDigitos));
    window.EyewearPagos.event = true;
    console.log("IFRAME","Payment Event On");
    var IntervalEvent = setInterval(()=>{
      if(window.EyewearPagos.paymentMethodId && window.EyewearPagos.issuer_id){
        this.paymentData.paymentMethodId = window.EyewearPagos.paymentMethodId;
        console.log("IFRAME",window.EyewearPagos.paymentMethodId);
        this.paymentData.issuer_id = window.EyewearPagos.issuer_id;
        this.imagenTarjeta = window.EyewearPagos.installments[0].issuer.secure_thumbnail;
        this.arrayInstallments = this.FiltrarInstallments(window.EyewearPagos.installments[0].payer_costs,10);
        this.VerificarTipoPago(window.EyewearPagos.installments[0].payment_type_id);
        console.log("IFRAME","Payment event Off",this.paymentData.issuer_id,window.EyewearPagos.issuer_id);
        clearInterval(IntervalEvent);
      }
      if(!window.EyewearPagos.event){
        console.log("IFRAME","Payment event Off");
        clearInterval(IntervalEvent);
      }
    },200);
  }
  pagar(){
    if(!this.tieneTarjeta){
      if(!this.paymentData.cardNumber){
        this.VerificarCampoPagos("Error","Favor complete el campo numero de tarjeta","#cardNumber");
        return;
      }else{
        var element = document.querySelector("#cardNumber") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.cardholderName){
        this.VerificarCampoPagos("Error","Favor complete el campo año nombre y apellido","#cardholderName");
        return;
      }else{
        var element = document.querySelector("#cardholderName") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.cardExpirationMonth){
        this.VerificarCampoPagos("Error","Favor complete el campo mes de vencimiento","#cardExpirationMonth");
        return;
      }else{
        var element = document.querySelector("#cardExpirationMonth") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.cardExpirationYear){
        this.VerificarCampoPagos("Error","Favor complete el campo año de vencimiento","#cardExpirationYear");
        return;
      }else{
        var element = document.querySelector("#cardExpirationYear") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.securityCode){
        this.VerificarCampoPagos("Error","Favor complete el campo código de seguridad","#securityCode");
        return;
      }else{
        var element = document.querySelector("#securityCode") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.docNumber){
        this.VerificarCampoPagos("Error","Favor complete el campo C.I.","#docNumber");
        return;
      }else{
        var element = document.querySelector("#docNumber") as HTMLElement;
        element.style.borderColor = "#969494";
      }
      if(!this.paymentData.email){
        this.VerificarCampoPagos("Error","Favor complete el campo email","#email");
        return;
      }else{
        var element = document.querySelector("#email") as HTMLElement;
        element.style.borderColor = "#969494";
      }
    }else{
      if(!this.paymentData.securityCode){
        this.VerificarCampoPagos("Error","Complete el campo codigo de seguridad","#securityCode");
        return;
      }else{
        var element = document.querySelector("#securityCode") as HTMLElement;
        element.style.borderColor = "#969494";
      }
    }
    if(!this.paymentData.amount){
      this.paymentData.amount = parseFloat(this.precioTotal);
    }
    this.DisabledBoton()
    console.log("IFRAME","paymentData",this.paymentData);
    if(this.ordenarPedido.Id_Customer){
      this.PrepararMercadoPago();
    }else{
      this.ComprobarCustomer();
    }
  }
  ComprobarCustomer(){
    let API_MERCADOPAGO = this.API_MERCADOPAGO;
    this.http.post(API_MERCADOPAGO + 'obtener_customer.php', this.paymentData).subscribe( (res) => {
      if(res.json().response == true){
          const confirm = this.emitModal({
            title: 'Error',
            message: 'Ya existe una tarjeta registrada con ese mail',
            dismiss: 0
          });
          this.EnableBoton();
      }else{
        this.PrepararMercadoPago();
      }
    });
  }
  ClienteCustomerId(){
    let API = this.API;
    var usuario = {
      Id:this.id
    }
    this.http.post(API + 'customer-by-id.php', usuario).subscribe( (res) => {
        console.log("IFRAME","Client Customer log: ", res.json() );
        if(res.json().response == true){
          this.ordenarPedido.Id_Customer = res.json().Id_Customer;
          this.paymentData.Id_Customer   = res.json().Id_Customer;
          this.CustomerGetCards();
        }else{
          this.ordenarPedido.Id_Customer = false;
        }
    })
  }
  PrepararMercadoPago(){
    console.log("IFRAME","Payment Pagar",this.paymentData);
    window.doPay(this.paymentData);
    console.log("IFRAME","doPay On");
    var IntervalEvent = setInterval(()=>{
      if(window.EyewearPagos.card_token_id){
        console.log("IFRAME","doPay Off",window.EyewearPagos.card_token_id);
        clearInterval(IntervalEvent);
        this.enviarMercadoPago();
      }
      if(window.EyewearPagos.error){
        clearInterval(IntervalEvent);
        console.log("IFRAME","doPay Error",window.EyewearPagos.error);
        if(window.EyewearPagos.error.cause[0]["code"] == "E302"){
          window.EyewearPagos.error.cause[0]["description"] = "Código de seguridad inválido"
        }
        if(window.EyewearPagos.error.cause[0]["code"] == "E325"){
          window.EyewearPagos.error.cause[0]["description"] = "Mes o año de expiración inválido"
        }
        this.emitModal({
          title: 'Error '+window.EyewearPagos.error.cause[0]["code"],
          message: window.EyewearPagos.error.cause[0]["description"],
          dismiss: 0
        })
        this.EnableBoton();
        //this.ResetearPago();
        this.guessingPaymentMethod();
      }
    },200);
  }
  enviarMercadoPago(){
    let API_MERCADOPAGO = this.API_MERCADOPAGO;
    console.log("IFRAME","Payment Event On");
    var IntervalEvent = setInterval(()=>{
      if(window.EyewearPagos.card_token_id){
        this.paymentData.token = window.EyewearPagos.card_token_id;
        this.paymentData.version = 4;
        console.log("IFRAME","Payment event Off");
        console.log("IFRAME","Enviar a api",this.paymentData);
        clearInterval(IntervalEvent);
        this.http.post(API_MERCADOPAGO + 'procesar_pago.php', this.paymentData).subscribe( (res) => {
          console.log("IFRAME","Enviar mercado log: ", res.json() );
          if(res.json().response == "approved" && res.json().id){
            this.paymentData.Id_Pago = res.json().id;
            this.guardarPedidoEyewear(this.paymentData.Id_Pago);
          }else{
            if(res.json().response == "rejected"){
              this.emitModal({
                  title: 'Error',
                  message: res.json().response+': '+res.json().status_detail,
                  dismiss: 0
                })
            }else{
              this.emitModal({
                title: 'Error',
                message: res.json().err.causes[0].description,
                dismiss: 0
              })
            }
            this.EnableBoton();
            //this.ResetearPago();
            //this.guessingPaymentMethod();
          }
        })
      }
    },200);
  }
  guardarPedidoEyewear(id_pago){
      this.ordenarPedido.Id_Cliente   = this.id;
      this.ordenarPedido.Id_Pago      = id_pago;
      this.ordenarPedido.Tipo         = this.tipoPayment;
      this.ordenarPedido.Total        = this.precioTotal;
      this.ordenarPedido.Subtotal     = this.precioSubtotal;
      this.ordenarPedido.Observacion  = "";
      let API = this.API;
      this.http.post(API + 'pedido-order.php', this.ordenarPedido).subscribe( (res) => {
        console.log("IFRAME","Gaurdar pedido log: ", res.json() );
        this.EnableBoton();
        if(res.json().response == true){
          this.CrearCustomer();
        }else{
          this.pictureTaken   = false;
          this.waitCam        = false;
          const confirm = this.emitModal({
            title: 'Error',
            message: 'Pedido no enviado Guardar Pedido ' + "\n" + JSON.stringify(res.json()),
            dismiss:0
          });
          this.reset();
          //this.EnableBoton();
        }
      })
  }
  CrearCustomer(){
    let API_MERCADOPAGO = this.API_MERCADOPAGO;
    this.http.post(API_MERCADOPAGO + 'crear_customer.php', this.paymentData).subscribe( (res) => {
        console.log("IFRAME","Customer log: ", res.json() );
        this.EnableBoton();
        if(res.json().id){
          this.GuardarCustomerID(res.json().id);
          setTimeout(()=>{
            this.emitMethod({"state": "ClienteCustomerId"});
            //this.ClienteCustomerId();
          },200);
        }else if(res.json().response){
          this.pictureTaken   = false;
          this.waitCam        = false;
          this.picture          = "";
          this.location = 'showPedidos';
          window.EyewearPagosReset();
          this.ResetearPago();
          this.showPedidos(true);
          this.ResetearPedido();
          this.emitMethod({"state": "ClienteCustomerId"});
          //this.ClienteCustomerId();
          const confirm = this.emitModal({
            title: 'Pedido realizado!',
            message: '',
            dismiss:4000
          });
          this.reset();
        }else{
          console.log("IFRAME","ERROR CUSTOMER",res.json());

          const confirm = this.emitModal({
            title: 'Error',
            message: 'Pedido no enviado Crear Customer' + "\n" + JSON.stringify(res.json()),
            dismiss:0
          });
          /*
          const confirm = this.emitModal({
            title: 'Error',
            message: 'Pedido no enviado',
            dismiss:0
          });*/
          this.DisabledBoton();
        }
    })
  }
  GuardarCustomerID(Id_Customer){
    let API = this.API;
    var customer = {
      Id:this.id,
      Id_Customer: Id_Customer
    }
    this.http.post(API + 'customer-crear.php', customer).subscribe( (res) => {
        console.log("IFRAME","Client Update log: ", res.json() );
        this.EnableBoton();
        if(res.json().response == true){
          this.pictureTaken   = false;
          this.waitCam        = false;
          this.picture          = "";
          this.location = 'showPedidos';
          this.EnableBoton();
          window.EyewearPagosReset();
          this.ResetearPago();
          this.showPedidos();
          const confirm = this.emitModal({
            title: 'Pedido realizado!',
            message: '',
            dismiss:4000
          });
          this.reset();
        }else{
          this.pictureTaken   = false;
          this.waitCam        = false;
          const confirm = this.emitModal({
            title: 'Error',
            message: 'Pedido no enviado GuardarCustomerId ' + "\n" + JSON.stringify(res.json()),
            dismiss:0
          });
          this.DisabledBoton();
        }
    })
  }
  CustomerGetCards(){
    let API_MERCADOPAGO = this.API_MERCADOPAGO;
    var customer = {
      Id_Customer: this.ordenarPedido.Id_Customer
    }
    this.http.post(API_MERCADOPAGO + 'tarjetas_customer.php', customer).subscribe( (res) => {
      try{
        console.log("IFRAME","Tarjetas log: ", res.json() );
        if(res.json().response.length > 0){
          this.customerTarjetas = res.json().response;
        }
      }catch(e){
        console.log("IFRAME",e);
      }
        
    })
  }
  /* FIN DE PAGOS WEB */
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts